import React, { useState, useEffect, useRef } from 'react';
function MSATable({ data, headers }) {
    const [isEditing, setIsEditing] = useState(false);
    const columns = data[0] ? Object.keys(data[0]) : [];
    const [activeCell, setActiveCell] = useState({ row: 0, col: 0 });
    const [activeHeader, setActiveHeader] = useState(0);


    const headersCellRefs = useRef([]);
    if (headersCellRefs.current.length !== headers.length) {
        headersCellRefs.current = Array(headers.length)
            .fill(null)
            .map(() => React.createRef());
    }

    //console.log("headersCellRefs.current", headersCellRefs.current)


    const cellRefs = useRef([]);
    // Initialize cellRefs.current based on the number of rows and columns
    if (cellRefs.current.length !== data.length) {
        cellRefs.current = Array(data.length)
            .fill(null)
            .map(() => Array(columns.length).fill(null).map(() => React.createRef()));
    }

    useEffect(() => {
        if (
            cellRefs.current[activeCell.row] &&
            cellRefs.current[activeCell.row][activeCell.col] &&
            cellRefs.current[activeCell.row][activeCell.col].current
        ) {
            //const cell = cellRefs.current[activeCell.row][activeCell.col].current;
            //cell.focus();
            //console.log(activeCell.row, activeCell.col)
            /*
            var range = document.createRange();
            var selection = window.getSelection();
            range.setStart(cell, cell.childNodes.length); // Place the cursor at the end of the cell content
            range.collapse(true); // Collapse the range to the cursor position
            selection.removeAllRanges();
            selection.addRange(range);
            */
        }
        else {
            console.log("invalid cell");
        }
    }, [activeCell]);

    const updateHeaders_MSATable = () => {
        //let headers1 = headers;
        headers[activeHeader + 1] = headersCellRefs.current[activeHeader + 1].current.textContent;
        //setHeaders(headers)
        const eventN = new Event('updateCSVHeader');
        eventN.Headers = headers;
        document.dispatchEvent(eventN);
    }

    const resetData = () => {
        cellRefs.current[activeCell.row][activeCell.col].current.textContent = data[activeCell.row][activeCell.col + 1]
    }

    const updateData = () => {
        //console.log(cellRefs.current[activeCell.row][activeCell.col].current.textContent);
        data[activeCell.row][activeCell.col + 1] = cellRefs.current[activeCell.row][activeCell.col].current.textContent;
        const eventN = new Event('updateCSVData');
        //console.log("Dataaaa_Pre", data)
        eventN.data = data;
        eventN.ColNo = activeCell.col + 1
        console.log("Dataaaa_Post", data)
        document.dispatchEvent(eventN);
    }

    const handDblClick = (e, row, col) => {
        let nextCol = activeCell.col;
        let nextRow = activeCell.row;
        //e.preventDefault();
        cellRefs.current[nextRow][nextCol].current.contentEditable = 'true';
        setActiveCell({ row: nextRow, col: nextCol })
        cellRefs.current[nextRow][nextCol].current.focus();
    }

    const highlightCellByArrow = (e) => {
        if (['Enter', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) >= 0) {
            if (e.target.className === 'first-row') {
                if (['Enter', 'Escape'].indexOf(e.key) >= 0) {
                    e.preventDefault();
                    headersCellRefs.current[activeHeader + 1].current.blur();
                    setActiveCell({ row: 0, col: activeHeader })
                    document.getElementById("csvTable").focus();
                    if ('Enter' === e.key) {
                        updateHeaders_MSATable()
                    }
                    else {
                        headersCellRefs.current[activeHeader + 1].current.textContent = headers[activeHeader + 1];
                    }
                    //cellRefs.current[0][activeHeader].current.focus();
                    //cellRefs.current[0][activeHeader].current.contentEditable = true;
                }
            }
            else {
                let nextCol = activeCell.col;
                let nextRow = activeCell.row;

                if (e.key === 'Enter') {
                    e.preventDefault();
                    if (cellRefs.current[nextRow][nextCol].current.contentEditable === 'false') {
                        cellRefs.current[nextRow][nextCol].current.contentEditable = 'true';
                        setActiveCell({ row: nextRow, col: nextCol })
                        cellRefs.current[nextRow][nextCol].current.focus();
                    }
                    else {
                        updateData();
                        cellRefs.current[nextRow][nextCol].current.contentEditable = 'false';
                        if (nextRow < data.length - 1) {
                            setActiveCell({ row: nextRow + 1, col: nextCol })
                            cellRefs.current[nextRow + 1][nextCol].current.contentEditable = 'true';
                            cellRefs.current[nextRow + 1][nextCol].current.focus();
                        }
                        else {
                            console.log()
                            setActiveCell({ row: nextRow, col: nextCol })
                        }
                    }
                }
                else if (e.key === 'Escape') {
                    e.preventDefault();
                    cellRefs.current[nextRow][nextCol].current.contentEditable = 'false';
                    resetData()
                    cellRefs.current[nextRow][nextCol].current.blur();
                    document.getElementById('csvTable').focus()
                }
                else if (cellRefs.current[nextRow][nextCol].current.contentEditable === 'false') {
                    e.preventDefault();
                    if (e.key === 'ArrowUp') {
                        nextRow = Math.max(nextRow - 1, 0);
                    }
                    else if (e.key === 'ArrowDown') {
                        nextRow = Math.min(nextRow + 1, data.length - 1);
                    }
                    else if (e.key === 'ArrowLeft') {
                        nextCol = Math.max(nextCol - 1, 0);
                    }
                    else if (e.key === 'ArrowRight') {
                        nextCol = Math.min(nextCol + 1, data[0].length - 2);
                    }
                    setActiveCell({ row: nextRow, col: nextCol })
                    const cell = cellRefs.current[nextRow][nextCol].current;
                    cell.focus();
                    cell.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
                }
            }
        }
    }

    const highlightCell = (e, RowNo, ColNo) => {
        e.preventDefault();
        setActiveCell({ row: RowNo, col: ColNo });
        var cell = document.getElementById('csvTable').rows[RowNo + 1].cells[ColNo + 1];
        cell.focus();
    }

    return (
        <table className='responsive' id="csvTable" onKeyDown={(e) => highlightCellByArrow(e)} tabIndex="0">
            <tbody>
                <tr>
                    {headers.map((key, index) => (
                        <td
                            contentEditable={true}
                            suppressContentEditableWarning={true}
                            key={index}
                            ref={headersCellRefs.current[index]}
                            className='first-row'
                            onClick={(e) => setActiveHeader(index - 1)}
                            style={{ width: '80px', paddingLeft: '0px', marginLeft: '0px', minWidth: index === 0 ? '20px' : '80px' }}
                        >
                            {key}
                        </td>
                    ))}
                </tr>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        <td
                            key={-1}
                            className="first-column" // Add a class for styling the first column
                        >
                            {row[columns[0]]}
                        </td>
                        {columns.slice(1).map((column, colIndex) => (
                            <td
                                key={colIndex}
                                contentEditable={isEditing && activeCell.row === rowIndex && activeCell.col === colIndex}
                                style={{ border: activeCell.row === rowIndex && activeCell.col === colIndex ? '2px solid #00B0F0' : '', width: '200px', paddingLeft: 0, marginLeft: 0 }}
                                ref={cellRefs.current[rowIndex][colIndex]}
                                suppressContentEditableWarning={true}
                                onClick={(e) => highlightCell(e, rowIndex, colIndex)}
                                onDoubleClick={(e) => { handDblClick((e, rowIndex, colIndex)) }}
                                onKeyDown={(e) => handleKeyPress(e)}
                            >
                                {row[column]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table >
    );
    function handleKeyPress(e) {
        const allowedCharacters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'Enter', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];
        if (!allowedCharacters.includes(e.key)) {
            e.preventDefault();
        }
    }
}

export default MSATable;
